export default {
  name: "App",
  methods: {},
  mounted() {
    window["callback"] = data => {
      window.location.href = data;
    };
  }
};